import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function FindResetPasswordService(token) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.get(
        `${URL_AUTH}/api/admin/v1/password/link/find/${token}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          },
        }
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}
